export default function initTabs(activeClassTab = "woocommerce-MyAccount-tab--active", activeClassContent = "woocommerce-MyAccount-tab-content--active") {
    const hashProgress = "#progress";
    const eventClick = new Event('click');
    const tabs = document.querySelectorAll('[data-tab-target]');
    const menuNavAccount = document.querySelectorAll('.woocommerce-account .header-ld-nav a');
    menuNavAccount?.forEach((el, i) => {
        el.addEventListener('click', () => {
            if (tabs) {
                tabs[i]?.dispatchEvent(eventClick);
            }
        })
    })

    tabs?.forEach((tab) => {
        tab.addEventListener('click', () => {
            tabs.forEach(
                (t) => t.classList.remove(activeClassTab)
            );
            tab.classList.add(activeClassTab);
            const target = tab.getAttribute('data-tab-target');
            const content = document.querySelector('[data-tab-content="' + target + '"]');

            document.querySelectorAll('[data-tab-content]').forEach(
                (c) => c.classList.remove(activeClassContent)
            );

            content.classList.add(activeClassContent);

            const url = window.location.href;

            if (target == 1) {
                if (url.indexOf('#') > -1) {
                    const newUrl = url.split('#')[0];
                    history.replaceState(null, null, newUrl);
                }
            }
            if (target == 2) {
                if (url.indexOf(hashProgress) === -1) {
                    const newUrl = url + hashProgress;
                    history.pushState(null, null, newUrl);
                }
            }
        });
    });

    if (tabs) {
        const hash = window.location.hash;
        const tabIndexProgress = 1;
        if (hash == hashProgress) {
            tabs[tabIndexProgress]?.dispatchEvent(eventClick);
        }
    }
}